
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";

@Component({
  name: "p-form-input-file",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
})
export default class PFormInputFile extends Vue {
  @Prop({ required: false, default: null }) value!: File | null;
  @Prop({ required: false, default: () => [] }) allowedTypes!: string[];
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false, default: "" }) placeholder!: string;
  @Prop({ required: false, default: "" }) rules!: string;
  @Prop({ required: false, default: "search" }) icon!: string;

  fileName = "";
  @Watch("value", { immediate: true })
  onValueChanged(newVal: File | null): void {
    this.selectedFile = newVal;
    this.fileName = newVal?.name || "";
  }

  get computedRules(): string {
    const baseRules = this.rules || "required";
    if (this.allowedTypes && this.allowedTypes.length > 0) {
      return `${baseRules}|file-is-permitted:${this.allowedTypes.join(",")}`;
    }
    return baseRules;
  }

  selectedFile: File | null = null;

  get displayName(): string {
    return this.fileName || "";
  }

  get computedPlaceholder(): string {
    return this.placeholder || (this.$t("label.selectFile") as string);
  }

  get acceptAttribute(): string {
    if (!this.allowedTypes || this.allowedTypes.length === 0) {
      return "";
    }
    return this.allowedTypes.map((t) => (t.includes("/") ? t : `.${t}`)).join(",");
  }

  triggerClick(): void {
    const fileInput = this.$refs.fileInput as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  handleFileUpload(): void {
    const fileInput = this.$refs.fileInput as HTMLInputElement;
    const file = fileInput?.files?.[0] || null;
    if (file) {
      this.selectedFile = file;
      this.fileName = file.name;
      this.$emit("input", file);
      this.$nextTick(() => {
        this.$emit("change", file);
        const observer = this.$refs.observer as InstanceType<typeof ValidationObserver> | undefined;
        observer?.validate();
      });
    } else {
      this.selectedFile = null;
      this.fileName = "";
      this.$emit("input", null);
      const observer = this.$refs.observer as InstanceType<typeof ValidationObserver> | undefined;
      observer?.validate();
    }
  }

  reset(): void {
    this.selectedFile = null;
    this.fileName = "";
    const fileInput = this.$refs.fileInput as HTMLInputElement;
    if (fileInput) {
      fileInput.value = "";
    }
    const observer = this.$refs.observer as InstanceType<typeof ValidationObserver> | undefined;
    observer?.reset();
  }
}
